import React from 'react';
import styles from './index.module.sass';
import { useTranslation } from 'react-i18next';

const TableBusinessSimulator = (props) => {
  const { screenSize = 'desktop', tableData = [], tableItems = [], type = '' } = props;
  const { t } = useTranslation('business');
  const columFieldsTab1 = t('columFieldsTab1', { returnObjects: true });
  const columFieldsTab2 = t('columFieldsTab2', { returnObjects: true });

  const dataCellWidth = (screenSize !== 'desktop' && '180px') || `${100 / tableItems.length}%`;

  return (
    <div className={`${styles.tableContainer}`}>
      <div className={styles.table}>
        <div className={`${styles.row} ${styles.tableHeader}`}>
          {tableItems.map((val, key) => {
            const { title = '' } = val;
            return (
              <div className={styles.cell} style={{ width: dataCellWidth }} key={key}>
                {title}
              </div>
            );
          })}
        </div>
        {tableData.map((val, key) => {
          const columns = tableItems.map((cellVal, cellKey) => {
            const { field = '' } = cellVal;
            let fieldName = '';

            if (type === 't1') {
              tableData[key].concepto = columFieldsTab1[key].title;
            } else {
              tableData[key].concepto = columFieldsTab2[key].title;
            }

            fieldName += (tableData[key] && tableData[key][field]) || '';

            const cell = (
              <div className={styles.cell} style={{ width: dataCellWidth }} key={cellKey}>
                {fieldName}
              </div>
            );
            return cell;
          });
          return (
            <div className={styles.row} key={key}>
              {columns}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TableBusinessSimulator;
